export default __webpack_public_path__ + "images/logo-colored_24a13c.svg";